import React from 'react';
import PropTypes from 'prop-types';
import css from './FixedBottomBar.module.scss';
import {useFixedBottomBarPosition} from '../../hooks/useFixedBottomBarPosition';

const FixedBottomBar = ({children, leftPosition}) => {
  const defaultLeftPosition = useFixedBottomBarPosition();
  const finalLeftPosition = leftPosition ?? defaultLeftPosition;

  return (
    <div className={css.fixedBar} style={{left: finalLeftPosition}}>
      {children}
    </div>
  );
};

FixedBottomBar.propTypes = {
  children: PropTypes.node.isRequired,
  leftPosition: PropTypes.string
};

export default FixedBottomBar;
